<template>

    <div>
        <apexchart 
            width="100%" 
            type="bar" 
            :options="options" 
            :series="series">
        </apexchart>
    </div>

</template>

<script>

import {ref, watch} from 'vue'
import VueApexCharts from "vue3-apexcharts"


export default {
    name: 'BarChart',
    components: {
        apexchart: VueApexCharts
    },
    props: {
        dataOptions: {
            type: Array,
            required: true
        },

        categories: {
            type: Array,
            required: true,
        },

        yaxis: {
            type: Object,
            required: false,
        },

        horizontal: {
            type: Boolean,
            required: false,
            default: true,
        }
    },

    setup(props) {
        const options = ref({
            chart: {
                id: 'bar'
            },
            plotOptions: {
                bar: {
                    horizontal: props.horizontal
                }
            },
            xaxis: {
                categories: props.categories
            },
            colors: ['#6266EA'],
        })
            
        const series = ref([{
            name: 'series-2',
            data: props.dataOptions
        }])


        watch(
            () => props.dataOptions, 
            () => series.value[0].data = props.dataOptions, { 
                deep: true 
            }
        )

        watch(
            () => props.yaxis,
            () => {
                console.log(props.yaxis)

                if (props.yaxis)
                    options.value['yaxis'] = props.yaxis
            },
            {
                deep: true
            }
        )

        return { options, series }
    }
}


</script>
